import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Colors, Sizes } from '@/components/ui/types';
import Fieldset from '../fieldset';
import { TextareaProps, TextareaVariant } from './types';

const sizeClasses: Record<Sizes, string> = {
  xs: 'textarea-xs',
  sm: 'textarea-sm',
  md: 'textarea-md',
  lg: 'textarea-lg',
  xl: 'textarea-xl',
};

const colorClasses: Record<Colors, string> = {
  default: '',
  neutral: 'textarea-neutral',
  primary: 'textarea-primary',
  secondary: 'textarea-secondary',
  accent: 'textarea-accent',
  info: 'textarea-info',
  success: 'textarea-success',
  warning: 'textarea-warning',
  error: 'textarea-error',
};

const variantClasses: Record<TextareaVariant, string> = {
  default: '',
  ghost: 'textarea-ghost',
};

const TextareaBase = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      className,
      size = 'md',
      color = 'default',
      variant = 'default',
      error = false,
      ...props
    },
    ref,
  ) => {
    const classes = twMerge(
      'textarea',
      sizeClasses[size],
      colorClasses[color],
      variantClasses[variant],
      error && 'textarea-error',
      className,
    );

    return <textarea ref={ref} className={classes} {...props} />;
  },
);

TextareaBase.displayName = 'Textarea';

export const Textarea = Object.assign(TextareaBase, {
  Fieldset,
});
